<template>
    <div>
        <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.1/dist/css/bootstrap.min.css" rel="stylesheet"
            integrity="sha384-+0n0xVW2eSR5OomGNYDnhzAbDsOXxcvSN1TPprVMTNDbiYZCxYbOOl7+AMvyTG2x" crossorigin="anonymous">
        <div v-show="modal" id="myModal" class="modal" @click.self="changeModal" ref="modalContent">
            <div class="modal-content">
                <div class="modal-header">
                    <h1>Pozri si video návod</h1>
                    <svg @click="changeModal" xmlns="http://www.w3.org/2000/svg" width="33" height="33"
                        viewBox="0 0 33 33" fill="none">
                        <path d="M8.25 24.75L24.75 8.25M8.25 8.25L24.75 24.75" stroke="#5C5C5C" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="modal-line"></div>
                <div class="modal-body">
                    <video id="video-container" width="100%" controls ref="videoRef">
                      <source src="/video/doffero_tutorial.mp4" type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from './EventBus';
export default {
    props: ['openModal'],
    data() {
        return {
            modal: false,
            seenVideo: 0,
        }
    },
    mounted() {
        EventBus.$on('seenVideo', (seenVideo) => {
            this.seenVideo = seenVideo;
            if (seenVideo == 0) {
                this.changeModal();
            }
        });
    },
    methods: {
        changeModal() {
            this.modal = !this.modal
            if (this.modal) {
                this.$refs.videoRef.play();
            } else {
                document.documentElement.style.overflow = 'auto';
                this.$refs.videoRef.pause();
                this.$emit('closeModal', false);
                if (this.seenVideo == 0) {
                    this.seenVideo = 1;
                    axios.post('/api/user/updateSeenVideo', {
                        seen_video: 1
                    }).then((response) => {
                      EventBus.$emit('seenVideo', 1);
                    });
                }
            }
        },
    },
    watch: {
        'openModal': function () {
            if (this.openModal) {
                this.changeModal()
            }
        },
    }
}
</script>
<style lang="scss" scoped>

@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap');

* {
    font-family: 'Roboto', sans-serif;
}


.modal {
    display: block;
    position: fixed;
    z-index: 1089;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background: rgba(33, 37, 65, 0.89);
    backdrop-filter: blur(5px);

    .modal-content {
        margin: 100px auto 100px auto;
        background: #F7F7F7;
        width: 674px;
        border-radius: 4px;
        box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.05);

        @media (max-width: 600px) {
            width: 95% !important;
            margin: 50px auto 50px auto;
        }

        .modal-line {
            width: 673px;
            height: 1px;
            background: #D73C78;

            @media (max-width: 600px) {
                width: 100% !important;
            }
        }

        .modal-header {
            margin: 35px auto;
            width: 578px;
            display: flex;
            align-items: center;
            padding: 0;
            border: none;

            @media (max-width: 600px) {
                width: 100% !important;
            }

            h1 {
                width: 427px;
                height: 34px;
                text-align: left;
                font-family: Roboto;
                font-size: 29px;
                font-style: normal;
                font-weight: 300;
                line-height: normal;
                color: #212541;

                @media (max-width: 600px) {
                    width: 100% !important;
                }
            }

            svg {
                transition: transform .5s;

                &:hover {
                    cursor: pointer;
                    transform: scale(1.3);
                }
            }
        }
        .modal-body {
            padding: 0;
            background-color: #F7F7F7;
            video {
                width: 100%;
                height: 100%;
                object-fit: cover;
                padding: 30px 15px 15px 15px;
            }
        }
    }
}
</style>
